// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3kwqM","inner":"Form_inner__2inh5","range":"Form_range__3QCCi","name":"Form_name__nTm6G","actions":"Form_actions__1SDBt"};